/* Layout */
import Layout from '@/layout'

/**
 * Note: sub-menu only appear when route children.length >= 1
 * Detail see: https://panjiachen.github.io/vue-element-admin-site/guide/essentials/router-and-nav.html
 *
 * hidden: true                   if set true, item will not show in the sidebar(default is false)
 * alwaysShow: true               if set true, will always show the root menu
 *                                if not set alwaysShow, when item has more than one children route,
 *                                it will becomes nested mode, otherwise not show the root menu
 * redirect: noRedirect           if set noRedirect will no redirect in the breadcrumb
 * name:'router-name'             the name is used by <keep-alive> (must set!!!)
 * meta : {
    roles: ['admin','editor']    control the page roles (you can set multiple roles)
    permissionKey:"",        control the page (控制权限,缺少该字段时不控制权限)
    title: 'title'               the name show in sidebar and breadcrumb (recommend set)
    icon: 'svg-name'/'el-icon-x' the icon show in the sidebar
    breadcrumb: false            if set false, the item will hidden in breadcrumb(default is true)
    activeMenu: '/example/list'  if set path, the sidebar will highlight the path you set
  }
 */

/**
 * constantRoutes
 * a base page that does not have permission requirements
 * all roles can be accessed
 */
export const constantRoutes = [
  {
    path: '/login',
    component: () => import('@/views/login/index'),
    hidden: true,
  },

  {
    path: '/404',
    component: () => import('@/views/404'),
    hidden: true,
  },
]

/**
 *
 * 动态路由，需要有权限
 */
export const asyncRoutes = [
  {
    path: '/',
    component: Layout,
    redirect: '/dashboard',
    children: [
      {
        path: 'dashboard',
        name: 'Dashboard',
        component: () => import('@/views/dashboard/index'),
        meta: { title: '首页', icon: 'iconfont icon-shouye sub-el-icon' },
      },
    ],
  },

  {
    path: '/task',
    component: Layout,
    redirect: '/task/list',
    name: 'task',
    meta: { title: '任务管理', icon: 'iconfont icon-renwuliebiao sub-el-icon' },
    children: [
      {
        path: 'list',
        name: 'taskList',
        component: () => import('@/views/task/index'),
        meta: {
          title: '任务列表',
          icon: 'iconfont icon-renwuliebiao sub-el-icon',
        },
      },
    ],
  },

  {
    path: '/robot',
    component: Layout,
    meta: {
      icon: 'iconfont icon-jiqirenguanli',
    },
    children: [
      {
        path: 'index',
        name: 'robot',
        component: () => import('@/views/robot/index'),
        meta: {
          title: '机器人管理',
          icon: 'iconfont icon-jiqirenguanli sub-el-icon',
        },
      },
    ],
  },

  {
    path: '/ditu',
    component: Layout,
    children: [
      {
        path: 'index',
        component: () => import('@/views/ditu/index'), // Parent router-view
        name: 'ditu',
        meta: {
          title: '地图管理',
          icon: 'iconfont icon-dituguanli sub-el-icon',
        },
      },
    ],
  },
  {
    path: '/poi',
    component: Layout,
    children: [
      {
        path: 'index',
        component: () => import('@/views/poi/index'), // Parent router-view
        name: 'poi',
        meta: {
          title: '地图点位管理',
          icon: 'iconfont icon-ditudianweiguanli sub-el-icon',
        },
      },
    ],
  },

  {
    path: '/user',
    component: Layout,
    meta: {},
    children: [
      {
        path: 'index',
        component: () => import('@/views/user/index'),
        meta: { title: '用户管理', icon: 'iconfont icon-huiyuan sub-el-icon' },
      },
    ],
  },

  // 404 page must be placed at the end !!!
  { path: '*', redirect: '/404', hidden: true },
]
